module.exports = __webpack_public_path__ + "img/img03.f7fc0cf8.png";